import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateLabelOpenShift", function updateLabelOpenShift(title: string) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.title = title;
    }
});